import React, { useContext, useEffect, useRef, useState } from 'react';

import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import useWarehouseOrderExpeditionService from '../../../app/services/hooks/useWareHouseOrderExpedition';
import { WarehouseOrderShowRateDataForm } from '../../../app/models/WareHouseOrderRates';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import WarehouseOrderExpeditionShowForm from './forms/WareHouseOrderExpeditionForms/WareHouseOrderExpeditionShowForm';
import LazyLoading from '../../../components/LazyLoading';




interface Props {
    expeditionId: number;
    onSaved?: () => void;
    onCancel: () => void;
    onError?: () => void;
}

const WarehouseOrderExpeditionShow = ({
    expeditionId,
    onSaved,
    onCancel,
    onError
}: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {showWarehouseOrderExpedition, fetchingShowWarehouseOrderExpedition} =
        useWarehouseOrderExpeditionService();

    const [showExpedition, setShowExpedition] = useState<WarehouseOrderShowRateDataForm>({});

    useEffect(() => {
        show();
    }, [expeditionId]);

    const show = () => {
        showWarehouseOrderExpedition(expeditionId, {
                onSuccess: (response: ServiceResponse) => {
                    setShowExpedition(response.data.expedition);
                },

        });
    };

    return (

        <>
        {!fetchingShowWarehouseOrderExpedition ? (
            <>
                <WarehouseOrderExpeditionShowForm
                    expeditionDataForm={showExpedition}

                />
            </>
        ) : (
            <LazyLoading />
        )}

        </>
    );
};

export default WarehouseOrderExpeditionShow;
